import { COLORS_FAMILY_KEY } from './colors-family-key';

export const FILTER_CODE_TO_PATH_MAP: Record<string, string> = {
  aw_product_stock_condition: 'product-stock',
  custom_option_size_ids: 'size',
  custom_option_color_ids: 'color',
  aw_general_fabric: 'fabric',
  aw_dresses_silhouette: 'silhouette',
  aw_dresses_hemline: 'hemline',
  aw_dresses_neckline: 'neckline',
  aw_dresses_backdetail: 'back-detail',
  aw_dresses_straps_sleeves: 'straps-sleeves',
  aw_general_embellishment: 'embellishment',
  aw_heel_height: 'heel-height',
  aw_heel_type: 'heel-type',
  price: 'price',
};

export const FILTER_CODE_MAP_TO_AGGREGATION_CODE: Record<string, string> = {
  aw_product_stock_condition: 'aw_product_stock_condition',
  custom_option_size_ids: 'aw_general_size',
  custom_option_color_ids: 'color',
  aw_general_fabric: 'aw_general_fabric',
  aw_dresses_silhouette: 'aw_dresses_silhouette',
  aw_dresses_hemline: 'aw_dresses_hemline',
  aw_dresses_neckline: 'aw_dresses_neckline',
  aw_dresses_backdetail: 'aw_dresses_backdetail',
  aw_dresses_straps_sleeves: 'aw_dresses_straps_sleeves',
  aw_general_embellishment: 'aw_general_embellishment',
  aw_heel_height: 'aw_heel_height',
  aw_heel_type: 'aw_heel_type',
  price: 'price',
};

export const FILTER_PATH_TO_CODE_MAP = Object.keys(FILTER_CODE_TO_PATH_MAP).reduce<Record<string, string>>(
  (acc, filterCode) => {
    acc[FILTER_CODE_TO_PATH_MAP[filterCode]] = filterCode;
    return acc;
  },
  {},
);

export const FILTER_AGGREGATION_CODE_TO_PATH_MAP: Record<string, string> = {
  aw_product_stock_condition: 'product-stock',
  aw_general_size: 'size',
  color: 'color',
  aw_general_fabric: 'fabric',
  aw_dresses_silhouette: 'silhouette',
  aw_dresses_hemline: 'hemline',
  aw_dresses_neckline: 'neckline',
  aw_dresses_backdetail: 'back-detail',
  aw_dresses_straps_sleeves: 'straps-sleeves',
  aw_general_embellishment: 'embellishment',
  aw_heel_height: 'heel-height',
  aw_heel_type: 'heel-type',
};

export const FILTER_PATH_TO_AGGREGATION_CODE_MAP = Object.keys(FILTER_AGGREGATION_CODE_TO_PATH_MAP).reduce<
  Record<string, string>
>((acc, filterCode) => {
  acc[FILTER_AGGREGATION_CODE_TO_PATH_MAP[filterCode]] = filterCode;
  return acc;
}, {});

export const FILTER_PATH_ORDER: Record<string, number> = {
  'product-stock': 1,
  color: 2,
  [COLORS_FAMILY_KEY]: 3,
  size: 4,
  fabric: 5,
  silhouette: 6,
  hemline: 7,
  neckline: 8,
  'back-detail': 9,
  'straps-sleeves': 10,
  embellishment: 11,
  'heel-height': 12,
  'heel-type': 13,
  price: 14,
  p: 100,
};
